/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_Misa_Sign_TypeInputs */

const vi_einvoice_settings_misa_sign_type = /** @type {(inputs: Einvoice_Settings_Misa_Sign_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại ký`)
};

/**

* @param {Einvoice_Settings_Misa_Sign_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_misa_sign_type = /** @type {((inputs?: Einvoice_Settings_Misa_Sign_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_Misa_Sign_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_misa_sign_type(inputs)
});